module.exports = "img/cancel-white.3709ff3.svg";